import { watch } from "vue";
import { useRouter } from "vue-router";
import type { RouteLocationNormalizedLoaded } from "vue-router";
import { storeToRefs } from "pinia";
import { useThemeStore } from "@/store/modules/theme";
import { APPLICATION_NAME, REDIRECT_PATH } from "@/config/setting";

function findTabByPath(path: string, tabs: any) {
  if (path == null || tabs == null) {
    return;
  }
  for (let i = 0; i < tabs.length; i++) {
    if (path === tabs[i].key || path === tabs[i].fullPath) {
      return tabs[i];
    }
  }
}

/**
 * 修改浏览器标题
 * @param title 标题
 */
export function setDocumentTitle(title: string) {
  const names: string[] = [];
  if (title) {
    names.push(title);
  }
  if (APPLICATION_NAME) {
    names.push(APPLICATION_NAME);
  }
  document.title = names.join(" - ");
}

/**
 * 路由切换更新浏览器标题
 */
export function useSetDocumentTitle() {
  const { currentRoute } = useRouter();
  const themeStore = useThemeStore();
  const { tabs } = storeToRefs(themeStore);

  const updateTitle = (route: RouteLocationNormalizedLoaded) => {
    const { path, meta, fullPath } = route;
    if (path.includes(REDIRECT_PATH)) {
      return;
    }
    const tab = findTabByPath(fullPath, tabs.value);
    const title = tab?.title || (meta?.title as string);
    setDocumentTitle(title);
    return;
  };

  watch(
    currentRoute,
    (route) => {
      updateTitle(route);
    },
    { immediate: true }
  );
}
